import type { CustomLineItem } from '@ab-core/graphql/dist';
import type { DefaultScalableProductCardProps } from '../cardLayout';
import { fallBackPosition, fallBackQuantityUnit, fallBackSalesUnit } from './fallBackStates';

const createCustomLineItemName = (product: CustomLineItem): string => {
    return `${product?.supplierName || ''} ${product?.name || ''} ${product?.supplierProductNumber || ''}`;
};

export const useCustomLineItemToScalableProduct = (
    products?: Array<CustomLineItem>
): Array<DefaultScalableProductCardProps['product']> => {
    const productList: Array<DefaultScalableProductCardProps['product']> = [];
    products?.forEach((product) => {
        productList.push({
            defaultQuantity: product.quantity || fallBackSalesUnit,
            defaultPositionText: product.positionText || '',
            sku: '',
            information: {
                reach: false
            },
            tags: {
                product: {
                    isAbakus: false,
                    isAbakusPlus: false,
                    isTecselect: false
                }
            },
            ids: {
                articleNumber: '',
                ean: product.ean || ''
            },
            image: {
                imgSrc: '',
                sku: ''
            },
            name: {
                text: createCustomLineItemName(product) || '',
                sku: ''
            },
            additionalLinks: {
                sku: '',
                hasAccessories: false,
                hasAlternatives: false
            },
            prices: {
                quantityUnit: product.quantityUnit || fallBackQuantityUnit,
                salesUnit: fallBackSalesUnit
            },
            availability: {
                availability: undefined,
                quantityUnit: product.quantityUnit || fallBackQuantityUnit
            },
            order: {
                quantityUnit: product.quantityUnit || fallBackQuantityUnit,
                salesUnit: fallBackSalesUnit,
                sku: '',
                isUnqualifiedContractProduct: false,
                chargeNr: '',
                packagingSize: '',
                position: fallBackPosition
            },
            comparison: {
                sku: '',
                title: product.name || '',
                imageSrc: ''
            }
        });
    });

    return productList;
};
